export default __webpack_public_path__ + "img/stock-800.02f6935e.jpg";